
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 md:mb-8">Pavane 소개</h1>
          <p className="text-lg md:text-xl lg:text-2xl text-gray-700 leading-relaxed mb-8 md:mb-12">
            우리는 일러스트레이션, 디자인, 작가 분야의 뛰어난 크리에이티브 인재를 대표하며, 독창성과 탁월함을 중시하는 브랜드와 비전 있는 아티스트를 연결합니다.
          </p>
        </div>
      </section>

      {/* Image Section */}
      <section className="px-4 md:px-8 mb-12 md:mb-20">
        <div className="max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-xl md:rounded-2xl aspect-[4/3] md:aspect-[16/9]">
            <img
              src="https://public.readdy.ai/ai/img_res/13451247856ab644715840f6ce71ff70.jpg"
              alt="Pavane Agency"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 md:mb-6">우리의 이야기</h2>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4 md:mb-6">
                2025년에 설립된 Pavane은 단순한 믿음에서 시작되었습니다. 크리에이티브가 뛰어난 사람들은 그에 맞는 대우를 받을 자격이 있다는 것입니다. 소수의 일러스트레이터로 시작하여 다양한 크리에이티브 전문가를 대표하는 에이전시로 성장해 나갈 예정입니다.
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                오늘날 우리는 주요 브랜드, 출판사, 에이전시와 협력하며 경계를 넘어서고 기대를 뛰어넘는 크리에이티브 솔루션을 제공합니다.
              </p>
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 md:mb-6">우리의 미션</h2>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4 md:mb-6">
                우리는 재능 있는 아티스트를 그들의 독특한 비전을 보여줄 수 있는 기회와 연결함으로써 새로운 기회들을 창출해 나갑니다. 우리의 미션은 의미 있는 협업과 혁신적인 작업을 통해 크리에이티브 산업을 향상시키는 것입니다.
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                우리는 신뢰, 존중, 그리고 뛰어난 크리에이티브 작업에 대한 공유된 열정을 바탕으로 구축된 장기적인 관계를 육성한다고 믿습니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light text-center mb-12 md:mb-16">우리의 가치</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className="ri-heart-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">열정</h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                우리는 창의적인 작업을 사랑하며, 그 열정이 우리가 하는 모든 일에 반영됩니다.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className="ri-team-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">협업</h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                우리는 아티스트와 클라이언트 간의 긴밀한 협력을 통해 최고의 결과를 만들어냅니다.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className="ri-star-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">탁월함</h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                우리는 아티스트 선정부터 프로젝트 전달까지 모든 일에서 최고 수준을 유지합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-light mb-4 md:mb-6">함께 작업하고 싶으신가요?</h2>
          <p className="text-lg md:text-xl text-gray-600 mb-6 md:mb-8 leading-relaxed">
            다음 프로젝트를 위한 완벽한 아티스트를 찾아드리겠습니다.
          </p>
          <a
            href="/contact"
            className="inline-block px-6 md:px-8 py-3 md:py-4 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-base md:text-lg"
          >
            문의하기
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
